import React from 'react';
import PropTypes from 'prop-types';

import BannerWithTagAndButton from '../../../components/BannerWithTagAndButton';

import { Heading4, Subtitle1 } from '../../../components/Typography';

import './index.scss';

const AdditionalInformation = ({ additionalInformation }) => {
  return (
    <div className='additional-information'>
      <Heading4 className='additional-information__title'>
        {additionalInformation.title}
      </Heading4>
      <Subtitle1 className='additional-information__description'>
        {additionalInformation.description}
      </Subtitle1>
      <div className='additional-information__banners'>
        {additionalInformation.banners.map((banner, index) => (
          <BannerWithTagAndButton
            key={index}
            image={banner.image}
            title={banner.title}
            description={banner.description}
            buttonText={banner.button.label}
            buttonUrl={banner.button.link}
          />
        ))}
      </div>
    </div>
  );
};

AdditionalInformation.propTypes = {
  additionalInformation: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    banners: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        button: PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired
        }).isRequired
      })
    ).isRequired
  })
};

export default AdditionalInformation;
